import { render } from "./MoreNews.vue?vue&type=template&id=0d5e214c&scoped=true"
import script from "./MoreNews.vue?vue&type=script&lang=js"
export * from "./MoreNews.vue?vue&type=script&lang=js"

import "./MoreNews.vue?vue&type=style&index=0&id=0d5e214c&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5e214c"]])

export default __exports__